define('gumbo-js-client-lib/forms/liveData/PlayerSeasonStatsForm',{
	batting: {
		avg: null,
		runs: null,
		assists: null,
		homeruns: null,
		strikeOuts: null,
		baseOnBalls: null,
		hits: null,
		putOuts: null,
		rbi: null,
		fielding: null,
		caughtStealing: null,
		stolenBases: null,
		onBasePlusSlugging: null
	},
	pitching: {
		hold: null,
		era: null,
		wins: null,
		loss: null,
		save: null,
		blownSave: null,
		inningsPitched: null,
		hits: null,
		runs: null,
		errors: null,
		baseOnBalls: null,
		strikeOuts: null,
		whip: null
	}
});
